module.exports = __webpack_public_path__ + "static/soft1-61c01079694b33252ce6f1c2e7f75a0b.gif";